/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * yesterday object
 * @export
 * @interface GetFwLeaderboardsYesterdayYesterday1
 */
export interface GetFwLeaderboardsYesterdayYesterday1 {
    /**
     * Amount of victory points
     * @type {number}
     * @memberof GetFwLeaderboardsYesterdayYesterday1
     */
    amount?: number;
    /**
     * faction_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsYesterdayYesterday1
     */
    factionId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsYesterdayYesterday1 interface.
 */
export function instanceOfGetFwLeaderboardsYesterdayYesterday1(value: object): value is GetFwLeaderboardsYesterdayYesterday1 {
    return true;
}

export function GetFwLeaderboardsYesterdayYesterday1FromJSON(json: any): GetFwLeaderboardsYesterdayYesterday1 {
    return GetFwLeaderboardsYesterdayYesterday1FromJSONTyped(json, false);
}

export function GetFwLeaderboardsYesterdayYesterday1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsYesterdayYesterday1 {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
    };
}

export function GetFwLeaderboardsYesterdayYesterday1ToJSON(json: any): GetFwLeaderboardsYesterdayYesterday1 {
    return GetFwLeaderboardsYesterdayYesterday1ToJSONTyped(json, false);
}

export function GetFwLeaderboardsYesterdayYesterday1ToJSONTyped(value?: GetFwLeaderboardsYesterdayYesterday1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'faction_id': value['factionId'],
    };
}

